import {vnModule} from "./vnModule";
import {vnAppZone} from "./vn_app_zone";
import {validationsList_template} from "../vnKnockoutJsTemplates/validationsList_template";
import {vn_app_zone_notification} from "./vn_app_zone_notification";
import {confirmationModal_template} from "../vnKnockoutJsTemplates/confirmationModal_template";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;
declare global {
    interface Window {
        opera: any;
    }
}

export abstract class vnModule_knockoutJS extends vnModule{
    
    // adding the viewModel object for knockoutJS purpose
    protected viewModel: any = {};
    protected template: any;
    protected XHRHdls: XMLHttpRequestHandler[] = [];

    // every modue will have ad efault validationList template to use so we can
    // have a generic treatment of validation result sets
    protected validationTemplate: validationsList_template;

    //
    // Modal to confirm takeover of lock.
    public confirmationModal: confirmationModal_template;

    constructor(vnAppZone: vnAppZone) {
        super(vnAppZone);

        this.validationTemplate = new validationsList_template("app_validationList", this.viewModel, this);

        this.confirmationModal = new confirmationModal_template('app_confirmationModal', this.viewModel, this);
        this.confirmationModal.setTitle('Locked');
        this.confirmationModal.setMessageSecondary('The editing user will lose their unsaved changes if you takeover. Would you like to takeover?');


        if (this.vnAppZone.getCookie('device') == null) {

            let device = this.mobileCheck() ? 'mobile' : 'desktop';
            this.vnAppZone.addCookie("device", device);
            this.vnAppZone.addCookie('deviceView', 'mobile');
        }

        let deviceView = this.vnAppZone.getCookie("deviceView");
        let bodyTag = document.getElementsByTagName("body")[0];

        // by default we want the mobile view.
        if(!deviceView){
            this.vnAppZone.addCookie('deviceView', 'mobile');
        }

        // if view is desktop aka forced by the UI, add the desktop class, else dont add a class at all
        if(deviceView == 'desktop' && !bodyTag.classList.contains(deviceView)){
            bodyTag.className += ' ' + deviceView;
        } else if(deviceView == 'mobile'){
            bodyTag.classList.remove('desktop');
        }
    }

    public build(): Array<HTMLElement>{

        this.content = [];

        this.content.push(this.validationTemplate.build());
        this.content.push(this.confirmationModal.build());

        for(let c of this.buildContent()){

            this.content.push(<HTMLElement>c);
        }

        return this.content;
    }

    //
    // overwriting the internal load to include the apply of the binding for knockout JS*
    protected internalLoad(container: HTMLElement){

        this.build();
        this.insertIn(container);

        // * see here
        for(let c of this.content){
            ko.applyBindings(this.viewModel, c);
        }

        this.loadSavedViewModule();

        this.fillPage();
    }

    protected loadSavedViewModule(){
        let saved_viewModel = this.getVnAppZone().getGlobal(this.getModuleName() + "_viewModel")
        if(saved_viewModel){
            this.loadViewModelFromViewModel(saved_viewModel);
        }
        this.getVnAppZone().removeGlobal(this.getModuleName() + "_viewModel");
    }

    protected saveViewModule(viewModel){
        this.getVnAppZone().addGlobal({index: this.getModuleName() + "_viewModel", value: viewModel});
    }

    protected savePreviousPage(pageTo, pageFrom){

        let pageFromPathAndParams = pageFrom.replace(window.location.origin, '');

        this.getVnAppZone().addGlobal( { index:pageTo , value: pageFromPathAndParams });
    }

    protected loadPreviousPage(currentPage){

        return this.getVnAppZone().getGlobal(currentPage);
    }

    protected loadViewModelFromViewModel(viewModel){
        for(let v in viewModel){
            if(typeof (viewModel[v]) != "function" && typeof (viewModel[v]) != "string"){
                for(let x in viewModel[v]){
                    if(typeof (viewModel[v][x]) != "function"){
                        this.viewModel["list"][v][x] = viewModel[v][x];
                    }else{
                        if(viewModel[v][x].name == "c"){
                            this.viewModel["list"][v][x](viewModel[v][x]());
                        }
                    }
                }
            }else if(typeof (viewModel[v]) == "function"){
                if(viewModel[v].name == "c"){
                    this.viewModel["list"][v](viewModel[v]());
                }
            }else if(typeof (viewModel[v]) == "string"){
                this.viewModel["list"][v] = viewModel[v];
            }
        }
    }

    protected manageResponse(req, obj, successFct){

        if(req.request.readyState == 4){

            if(req.request.status == 200){

                if(successFct){

                    successFct(req, obj);
                }
                obj.validationTemplate.clearMessages();

            }else if(req.request.status == 423){

                let responseParsed = JSON.parse(req.request.response);
                let lastRoute = obj.getVnAppZone().app.getLastRoute();

                if(responseParsed.hasOwnProperty('isTakeoverAllowed') && responseParsed.isTakeoverAllowed){

                    obj.confirmationModal.setContext('takeover');
                    obj.confirmationModal.setDataClose(lastRoute);
                    obj.confirmationModal.setMessageMain(responseParsed.message);
                    obj.confirmationModal.show();
                }else{

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    page.redirect(lastRoute);
                }
            }else if(req.request.status == 400){

                let responseParsed = JSON.parse(req.request.response);
                obj.validationTemplate.setMessages(responseParsed.validations);
                window.scrollTo(0, 0);
            }else if(req.request.status == 401){

                let originalResponseParsed = JSON.parse(req.request.response);
                let lastRoute = obj.getVnAppZone().app.getLastRoute();

                // Must make a separate call to the backend to figure out if the user is truly logged in (app.loggedUser.isLoggedIn might be stale)
                let loginReq_url: string = obj.getVnAppZone().getApp().getIsLoggedInHttpCallUrl();
                let loginReq_Params: Array<Array<string>> = obj.getVnAppZone().getApp().getIsLoggedInHttpCallParameters();

                let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(loginReq_url,loginReq_Params, this);

                XHRHdl.onReadyStateFunction = (function(req, obj){

                    return function(){

                        if (req.request.readyState == 4){

                            if(  req.request.status == 200  ){

                                let responseParsed = obj.getVnAppZone().getApp().getIsLoggedInHttpCallResponse(JSON.parse(req.request.response));
                                if (responseParsed.isLoggedIn === true){

                                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, originalResponseParsed.message);
                                    page.redirect(lastRoute);
                                }
                                else{

                                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, originalResponseParsed.message);
                                    page.redirect('/');
                                }
                            }
                            else{
                                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, originalResponseParsed.message);
                                page.redirect('/');
                            }
                        }
                    }
                });
                XHRHdl.execute();
            }else{

                if(req.request.status != "0"){

                    try {
                        let responseParsed = JSON.parse(req.request.response);

                        obj.validationTemplate.setSingleMessage({
                            field: "error",
                            "label": '',
                            message: responseParsed.message
                        });
                    } catch (e){
                        obj.validationTemplate.setSingleMessage({
                            field: "error",
                            "label": req.request.status,
                            message: 'Something went wrong !'
                        });
                    }
                    window.scrollTo(0, 0); 
                }
            }
        }
    }

    public updateViewModelFromPath(){

        let urlParams = this.getUrlParmsFromPath();

        if(Object.keys(urlParams).length != 0 && Object.keys(urlParams)[0] !== "undefined"){

            this.template.setViewModelFromRequest(urlParams);
        }
    }



    public getUrlParmsFromPath(){

        let path = window.location.href;

        let queryString = window.location.href.split('?')[1];
        queryString = decodeURIComponent(queryString);
        let urlParams = [];

        if(queryString){

            let urlParamsSections = queryString.split("&");


            for(let urlParamsSection of urlParamsSections){

                let urlKeyValue = urlParamsSection.split("=");
                urlKeyValue[1] = decodeURIComponent(urlKeyValue[1]);

                if(this.isJson(urlKeyValue[1])){

                    urlKeyValue[1] = JSON.parse(urlKeyValue[1]);
                }

                urlParams[urlKeyValue[0]] = urlKeyValue[1];
            }
        }

        return urlParams;
    }

    private isJson(str){
        try {
            JSON.parse(str);
        } catch (e){
            return false;
        }
        return true;
    }

    public sendFilterCall(baseUrl, viewModelParams, returnFunction, callType = XMLHttpRequestHandler_requestType.GET, callIdentifier = '', loadItem = null, replaceUrl = true){

        let callKey = '';

        // If callIdentifier is specified, it means we want to make sure to cancel previous requests with the same identifier before sending this call.
        if(callIdentifier != ''){

            callKey = baseUrl + '-' + callIdentifier;

            if(callKey in this.XHRHdls){

                this.XHRHdls[callKey].cancelAndReset();
            }
        }
        if(loadItem){
            this.loadingIn(loadItem);
        }

        let filterParams = viewModelParams;
        if(viewModelParams.filters){
            filterParams = viewModelParams.filters;
        }

        if(replaceUrl){
            this.updateFilterUrl(baseUrl, filterParams);
        }

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(['data', ko.toJSON(viewModelParams)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(baseUrl, usrReq_params, this);
        XHRHdl.mode = callType;

        XHRHdl.onReadyStateFunction = returnFunction;
        XHRHdl.execute();

        // Keep track the call so we can cancel it later if needed.
        if(callKey != ''){

            this.XHRHdls[callKey] = XHRHdl;
        }
    }

    public updateFilterUrl(baseUrl, viewModelParams){

        // @ts-ignore
        let clonedViewModelParams = Object.assign({}, viewModelParams);

        //build the url

        let queryString = '';

        let firstParam = true;

        for(let key in clonedViewModelParams){

            let paramValue = clonedViewModelParams[key];

            if(paramValue == null){

                continue;
            }

            if(Array.isArray(paramValue)){
                if(paramValue.length == 0){
                    continue;
                }

                paramValue = JSON.stringify(paramValue);
                paramValue = encodeURIComponent(paramValue);
            }
            
            if(typeof paramValue === 'object'){

                //specifically for hiding columns
                if(key == "hideColumns"){
                    let columns = paramValue;
                    let resultArray = Object.keys(columns).map(function(indx){
                        let column = columns[indx];
                        if(!column){
                            return indx;
                        }
                        return null;
                    });
                    paramValue = resultArray.filter(val => val);
                    if(paramValue.length == 0){
                        continue;
                    }
                }
                paramValue = JSON.stringify(paramValue);
                paramValue = encodeURIComponent(paramValue);
            }

            if(typeof paramValue === 'function'){

                let functionValue = paramValue();
                if(functionValue){
                    paramValue = JSON.stringify(functionValue);
                    paramValue = encodeURIComponent(functionValue);
                }else{
                    continue;
                }
            }

            if(paramValue !== ""){

                if(firstParam){

                    queryString = queryString + key + '=' + paramValue;
                    firstParam = false;
                }else{

                    queryString = queryString + '&' + key + '=' + paramValue;
                }
            }
        }

        let rootPath = window.location.href.split('?')[0];
        let path = rootPath;

        if(queryString){
            path = rootPath + "?" + queryString;
        }

        window.history.replaceState(window.history.state, document.title, path);
        this.getVnAppZone().getApp().routeHistory[this.getVnAppZone().getApp().routeHistory.length - 1] = path;
    }

    //
    // Hook.
    // Handles on confirm button click event from modal.
    public confirmationModalOnClickConfirm(context, data): void {

    };

    //
    // Hook.
    // Handles on close button click event from modal.
    public confirmationModalOnClickClose(context, data): void {

    };

    //
    // Determines if logged in user has a role.
    public isOfRole(role: Number){

        let show = false;
        let vnApp = this.getVnAppZone().app;
        let roles: Array<any> = this.getVnAppZone().getApp().loggedUser.user.valnet_user.roles;
        let roleIds = [];

        for(let role of roles){

            roleIds.push(role.id);
        }

        if(roleIds.indexOf(role) > -1){

            show = true;
        }

        return show;
    }

    //
    // Determines if user has access to page.
    public hasAccessToSection(idSection: Number, accessType: string = ''): boolean {

        if(this.isOfRole(1)){

            return true;
        }

        let vnApp = this.getVnAppZone().app;
        let roles: Array<any> = this.getVnAppZone().getApp().loggedUser.user.valnet_user.roles;

        for(let role of roles){

            for(let section of role.sections){

                if(section.idSection === idSection){

                    if((accessType && section.access_arr.includes(accessType)) || (!accessType && section.access_arr.length > 0)){

                        return true;
                    }else{

                        return false;
                    }
                }
            }
        }

        return false;
    }
    
    public getPresetType(){

        return this.getModuleName();
    }

    public redirectToPreset(queryString){

        let rootPath = window.location.href.split('?')[0];
        let path = rootPath + queryString;
        window.history.replaceState(window.history.state, document.title, path);
        this.getVnAppZone().getApp().routeHistory[this.getVnAppZone().getApp().routeHistory.length - 1] = path;
    }

    protected getSearchPresetsListData(): void{

        if("getSearchPresetsListData" in this.XHRHdls){

            // @ts-ignore
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let data = {type: this.getModuleName()};

        let subViewModel = JSON.parse(ko.toJSON(data));
        let usrReq_url: string = '/api/search_preset/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['getSearchPresetsListData']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function (){

                let response = JSON.parse(req.request.response);
                obj.template.presetFilter.setSearchPresets(response);

                // If there is a favorite and we don't have a query string, redirect to that favorite
                let favorite = obj.template.presetFilter.getTemplateViewModel().searchPresetFavorite();

                if(favorite.id != null && window.location.search.length == 0){

                    obj.redirectToPreset(favorite.queryString);
                }

                obj.getListFormData();
            });
        }
    }

    protected saveSearchPreset(){

        if("saveSearchPreset" in this.XHRHdls){

            // @ts-ignore
            this.XHRHdls["saveSearchPreset"].cancelAndReset();
        }

        let formReq_url: string = '/api/search_preset/save';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.template.presetFilter.getViewModelForPresetRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onPostSearchPreset
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onPostSearchPreset(req, obj): Function{

        return function (){

            obj.manageResponse(req, obj, function (){

                let response = JSON.parse(req.request.response);

                if(req.request.status == 200){

                    obj.template.presetFilter.addCreatedPresetToList(response);
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Preset saved successfully.");
                }else{

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, "Preset could not be saved.");
                }

                obj.getVnAppZone().showNotificationToModule();
            });
        }
    }

    protected saveFavoriteSearchPreset( params: {presetId: number, searchPresetType: string}): void{

        if("saveFavoriteSearchPreset" in this.XHRHdls){

            // @ts-ignore
            this.XHRHdls["saveFavoriteSearchPreset"].cancelAndReset();
        }
        let formReq_url: string = '/api/search_preset/favorite/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(params));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['saveFavoriteSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveFavoriteSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveFavoriteSearchPreset'].onReadyStateFunction = this.onPostFavoriteSearchPreset
        this.XHRHdls['saveFavoriteSearchPreset'].execute();
    }

    private onPostFavoriteSearchPreset(req, obj): Function {
        return function (){
            obj.manageResponse(req, obj, function (){

            });
        }
    }

    protected deleteSearchPreset(presetId: number): void {

        if("deleteSearchPreset" in this.XHRHdls){

            // @ts-ignore
            this.XHRHdls["deleteSearchPreset"].cancelAndReset();
        }

        let usrReq_url: string = '/api/search_preset/delete/' + presetId + '/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['deleteSearchPreset'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['deleteSearchPreset'].onReadyStateFunction = this.onDeleteSearchPresetReturn;
        this.XHRHdls['deleteSearchPreset'].execute();
    }

    protected onDeleteSearchPresetReturn(req, obj): Function{

        return () => {

            obj.manageResponse(req, obj, function (){

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Preset deleted successfully.");
                obj.getVnAppZone().showNotificationToModule();
            });
        }
    }

    public onClickBookmarkPreset(url): void {

        // Copy the bookmark to clipboard
        window.navigator['clipboard'].writeText(url);

        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Preset bookmark copied to clipboard.");
        this.getVnAppZone().showNotificationToModule();
    }
    //
    // Handles navigation for new tab with key press
    protected handleNavigation(url, event){

        if (event.ctrlKey || event.metaKey || event.which === 2) {

            // Open link in a new tab if Ctrl/Cmd is pressed or if the middle mouse button is clicked
            window.open(url, '_blank');
        } else {

            // Otherwise, open the link in the same tab
            page(url);
        }
    }

    protected mobileCheck(){

        console.log(this.getVnAppZone().getGlobal('checking device...'));

        let check = false;

        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    }
    
}




// WEBPACK FOOTER //
// ./vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS.ts